/* RIMAL theme scripts: reveal on scroll, save for later */
(function () {
  var els = document.querySelectorAll('[data-r-reveal]');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }
})();

(function () {
  var KEY = 'rimal:saved';
  var SAVED_URL = '/pages/saved';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.4-4.5-9.2-9.2C1.6 7.8 3.7 4.6 7 4.6c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.3 0 5.4 3.2 4.2 6.5-1.8 4.7-9.2 9.2-9.2 9.2z"/></svg>';

  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }

  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'r-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function sync() {
    var a = read();
    document.querySelectorAll('[data-r-save]').forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-r-save')) > -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from saved' : 'Save for later');
      var l = b.querySelector('.r-save__label');
      var lt = on ? 'Saved' : 'Save for later';
      if (l && l.textContent !== lt) l.textContent = lt;
    });
    document.querySelectorAll('.r-saved-count').forEach(function (c) {
      if (c.textContent !== String(a.length)) c.textContent = a.length;
      c.hidden = a.length === 0;
    });
  }

  function handleFrom(href) {
    if (!href || href.indexOf('/products/') < 0) return null;
    return href.split('/products/')[1].split(/[?#/]/)[0];
  }

  function injectCards() {
    document.querySelectorAll('product-card').forEach(function (pc) {
      if (pc.querySelector('[data-r-save]')) return;
      var link = pc.querySelector('a[href*="/products/"]');
      var h = link && handleFrom(link.getAttribute('href'));
      if (!h) return;
      var host = pc.querySelector('.card-gallery') || pc;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'r-save';
      b.setAttribute('data-r-save', h);
      b.innerHTML = HEART;
      host.appendChild(b);
    });
  }

  function injectHeader() {
    if (document.querySelector('.r-saved-link')) return;
    var ha = document.querySelector('header-actions');
    if (!ha) return;
    var a = document.createElement('a');
    a.href = SAVED_URL;
    a.className = 'header-actions__action r-saved-link';
    a.setAttribute('aria-label', 'Saved pieces');
    a.style.cssText = 'display:inline-grid !important;place-items:center;width:44px;height:44px;';
    a.innerHTML = HEART + '<span class="r-saved-count" hidden>0</span>';
    var cart = ha.querySelector('cart-drawer-component, cart-icon, [class*="cart"]');
    var anchor = cart;
    while (anchor && anchor.parentElement !== ha) anchor = anchor.parentElement;
    if (anchor) ha.insertBefore(a, anchor); else ha.appendChild(a);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-r-save]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-r-save');
    var a = read();
    var on = a.indexOf(h) > -1;
    a = on ? a.filter(function (x) { return x !== h; }) : [h].concat(a);
    write(a);
    sync();
    b.classList.add('is-pop');
    setTimeout(function () { b.classList.remove('is-pop'); }, 300);
    toast(on ? 'Removed from saved' : 'Saved for later <a href="' + SAVED_URL + '">View</a>');
    var grid = document.querySelector('[data-r-saved-grid]');
    if (grid && on) {
      var item = b.closest('[data-r-saved-item]');
      if (item) item.remove();
      emptyState();
    }
  }, true);

  function emptyState() {
    var grid = document.querySelector('[data-r-saved-grid]');
    var empty = document.querySelector('[data-r-saved-empty]');
    if (!grid || !empty) return;
    empty.hidden = grid.children.length > 0;
  }

  function renderSavedPage() {
    var grid = document.querySelector('[data-r-saved-grid]');
    if (!grid) return;
    var a = read();
    if (!a.length) { emptyState(); return; }
    Promise.all(a.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=rimal-card-api', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (list) {
      list.forEach(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.r-card');
        if (!card) return;
        var wrap = document.createElement('div');
        wrap.setAttribute('data-r-saved-item', '');
        wrap.appendChild(card);
        grid.appendChild(wrap);
      });
      emptyState();
      sync();
    });
  }

  function init() {
    injectHeader();
    injectCards();
    renderSavedPage();
    sync();
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { injectHeader(); injectCards(); sync(); }, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Hero video: load only the source for the visible breakpoint */
(function () {
  function start() {
    document.querySelectorAll('.r-hero__media video').forEach(function (v) {
      if (v.offsetParent === null || v.dataset.rLoaded) return;
      var s = v.querySelector('source[data-src]');
      if (!s) return;
      s.src = s.getAttribute('data-src');
      v.dataset.rLoaded = '1';
      /* first play starts after the fade in, so the poster hands over without a dark flash */
      v.addEventListener('loadedmetadata', function () { try { v.currentTime = 0.55; } catch (e) {} }, { once: true });
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('resize', start);
})();

/* Free shipping progress in the cart drawer */
(function () {
  var THRESHOLD = 10000;
  var busy = false, last = '';
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function render(total) {
    var host = document.querySelector('cart-drawer-component .cart-drawer__items');
    if (!host) return;
    var el = host.querySelector('.r-ship');
    if (!el) {
      el = document.createElement('div');
      el.className = 'r-ship';
      el.innerHTML = '<p></p><div class="r-ship__bar"><span></span></div><small class="r-ship__note" style="display:block;margin-top:8px;font-size:12px;line-height:1.4;opacity:.75">Shipping to a Packstation? At checkout, enter "Packstation" and its number as the address and your DHL Postnummer in the second address line.</small>';
      host.insertBefore(el, host.firstChild);
    }
    var left = THRESHOLD - total;
    var html = left > 0 ? 'You are <strong>' + money(left) + '</strong> away from free shipping.' : '<strong>Free shipping</strong> unlocked. Your order ships tracked with DHL.';
    var p = el.querySelector('p');
    if (p.innerHTML !== html) p.innerHTML = html;
    el.classList.toggle('is-free', left <= 0);
    el.querySelector('span').style.width = Math.min(100, Math.round(total / THRESHOLD * 100)) + '%';
    el.hidden = total === 0;
  }
  function update() {
    var host = document.querySelector('cart-drawer-component .cart-drawer__items');
    if (!host || busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      busy = false; last = String(c.total_price); render(c.total_price);
    }).catch(function () { busy = false; });
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(function () {
    var host = document.querySelector('cart-drawer-component .cart-drawer__items');
    if (host && !host.querySelector('.r-ship')) { if (last) render(+last); }
    update();
  }, 250); }
  function init() {
    update();
    var d = document.querySelector('cart-drawer-component');
    if (d && 'MutationObserver' in window) new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (!(m[i].target.closest && m[i].target.closest('.r-ship'))) { schedule(); return; } }
    }).observe(d, { childList: true, subtree: true });
    document.addEventListener('cart:update', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Delivery estimate and recently viewed on the product page */
(function () {
  function addWorkdays(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }
  function fmt(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function eta() {
    document.querySelectorAll('[data-r-eta]').forEach(function (el) {
      var now = new Date();
      var from = addWorkdays(now, 5), to = addWorkdays(now, 9);
      el.textContent = 'Order today, arrives ' + fmt(from) + ' to ' + fmt(to) + '.';
    });
  }
  var KEY = 'rimal:recent';
  function recent() {
    var cur = document.querySelector('[data-r-current]');
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
    var handle = cur && cur.getAttribute('data-r-current');
    var show = list.filter(function (h) { return h !== handle; }).slice(0, 4);
    if (handle) {
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var sec = document.querySelector('[data-r-recent]');
    var grid = sec && sec.querySelector('[data-r-recent-grid]');
    if (!grid || !show.length) return;
    Promise.all(show.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=rimal-card-api', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      htmls.forEach(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var card = tmp.querySelector('.r-card'); if (!card) return;
        var w = document.createElement('div'); w.appendChild(card); grid.appendChild(w);
      });
      if (grid.children.length) sec.hidden = false;
      document.dispatchEvent(new CustomEvent('rimal:cards'));
    });
  }
  function init() { eta(); recent(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Default size M on product pages instead of the first size (2XS) */
(function () {
  if (location.pathname.indexOf('/products/') < 0) return;
  if (new URLSearchParams(location.search).get('variant')) return;
  var tries = 0;
  function pick() {
    var picker = document.querySelector('main variant-picker');
    var m = picker && picker.querySelector('input[type=radio][name^="Size"][value="M"]');
    if (!m) { if (++tries < 20) setTimeout(pick, 150); return; }
    var cur = picker.querySelector('input[type=radio][name^="Size"]:checked');
    if (cur && cur.value !== '2XS') return;
    if (!m.checked && !m.disabled) m.click();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pick); else pick();
})();


/* Product gallery: show only the selected colour's photos */
(function () {
  if (location.pathname.indexOf('/products/') < 0) return;
  var t;
  function run() {
    var picker = document.querySelector('main variant-picker');
    var gallery = document.querySelector('main media-gallery');
    if (!picker || !gallery) return;
    var radios = picker.querySelectorAll('input[type=radio][name^="Color"]');
    if (!radios.length) return;
    var colours = Array.prototype.map.call(radios, function (r) { return r.value; });
    var checked = picker.querySelector('input[type=radio][name^="Color"]:checked');
    if (!checked) return;
    var sel = checked.value.toLowerCase();
    function colourOf(alt) {
      alt = (alt || '').toLowerCase();
      for (var i = 0; i < colours.length; i++) {
        if (alt.indexOf(' in ' + colours[i].toLowerCase() + ',') > -1 || alt.indexOf(' in ' + colours[i].toLowerCase() + ' ') > -1) return colours[i].toLowerCase();
      }
      return null;
    }
    var groups = [gallery.querySelectorAll('slideshow-slide'), gallery.querySelectorAll('li.product-media-container')];
    var shown = 0;
    groups.forEach(function (list) {
      Array.prototype.forEach.call(list, function (el) {
        var img = el.querySelector('img');
        var c = colourOf(img && img.alt);
        var hide = c !== null && c !== sel;
        el.classList.toggle('r-hide-colour', hide);
        if (!hide) shown++;
      });
    });
    var slides = gallery.querySelectorAll('slideshow-slide');
    var dots = gallery.querySelectorAll('slideshow-controls li, .slideshow-controls li');
    if (dots.length === slides.length) {
      Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('r-hide-colour', slides[i].classList.contains('r-hide-colour')); });
    }
  }
  function schedule() { clearTimeout(t); t = setTimeout(run, 60); }
  function init() {
    run();
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.name && e.target.name.indexOf('Color') === 0) schedule(); });
    document.addEventListener('variant:update', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
